import { useEffect } from 'react';

const useUnmount = (fn, hook = useEffect) => hook(() => () => fn && fn(), []);

export default useUnmount
